/**
 * AXIS
 */

import getLabelShort from "@/utils/get-label-short.utils"
import getLabel from "@/utils/get-label.utils"
import { ProjectAxisRule } from "./project.types"
import { Population } from "./population.types"
import { t } from "@/translate/t"
import { getAxisImageUrl } from "@/utils/get-image-url"

export class Axis {
  color: string = "#c1c1c1"
  id: string = ""
  image: string | null = null
  defaultImage: boolean = false
  name: any = {}
  note: number = 0
  open: boolean = false
  usersCount: number = 0

  constructor(axis: Partial<Axis> = {}) {
    Object.assign(this, axis)
  }

  //Get label from langague
  get label(): string {
    return getLabel(this.name)
  }

  //Cut label
  get labelShort(): string {
    return getLabelShort(this.label)
  }

  get picture(): string {
    return getAxisImageUrl(String(this.image), this.defaultImage)
  }

  //Check if an axis should be displayed according the populationsObserver settings for the connected user
  isDisplayed(segmentationByAxesRules: ProjectAxisRule[], populationsObserver: Population[]): boolean {
    const axisRule = segmentationByAxesRules.find((x) => x.axisId === this.id)
    if (axisRule && populationsObserver.length > 0) {
      let isDisplayed = false
      for (let i = 0; i < populationsObserver.length; i++) {
        const item = populationsObserver[i]
        const population = axisRule.populations.find((x) => x.filterName === item.filterName && x.name === item.name)
        if (population) {
          isDisplayed = true
          break
        }
      }

      return isDisplayed
    } else {
      return true
    }
  }

  getAttributesLabel(axesInvited): string {
    const axisInvited = axesInvited.find((x) => x.id === this.id)
    if (axisInvited) {
      return axisInvited.attributesLabel.map((x) => t(x)).join(", ")
    } else {
      return ""
    }
  }

  getAttributesLabelShort(axesInvited): string {
    const label = this.getAttributesLabel(axesInvited)
    return getLabelShort(label)
  }

  getNoteLabel(dashboardDisplayMode: string): string {
    if (!this.note) {
      return ""
    } else if (dashboardDisplayMode === "note") {
      return (this.note / 10).toFixed(1)
    } else {
      return this.note.toFixed(0) + "%"
    }
  }
}

export interface AxisState {
  active: Axis
  list: Axis[]
  status: string
}

export const CONFIG_AXIS_COLORS = [
  "#0079BF", // bleu primary (bleu dashboard)
  "#61BD4F", // vert succès
  "#FFAB4A", // orange doux
  "#EB5A46", // rouge alerte
  "#C377E0", // violet vibrant
  "#FF80CE", // rose pop
  "#00C2E0", // cyan lumineux
  "#42548E", // bleu navy
  "#00B8A9", // teal vif
  "#F2D600", // jaune lumineux
  "#FF5C8A", // rose punchy
  "#8ED1FC", // bleu clair frais
  "#A5D6A7", // vert doux mais visible
  "#FF8C42", // orange soutenu
  "#6E8EF5", // bleu pervenche moderne
  "#2ECC71", // vert vif dynamique
  "#FF6B6B" // corail énergique
]

export const AXIS_ACTIVATE = "AXIS_ACTIVATE"
export const AXIS_ADD = "AXIS_ADD"
export const AXIS_COPY = "AXIS_COPY"
export const AXIS_EDIT = "AXIS_EDIT"
export const AXIS_EDIT_NAME = "AXIS_EDIT_NAME"
export const AXIS_GET = "AXIS_GET"
export const AXIS_INIT = "AXIS_INIT"
export const AXIS_OPEN = "AXIS_OPEN"
export const AXIS_REMOVE = "AXIS_REMOVE"
export const AXIS_STATUS = "AXIS_STATUS"
export const AXIS_SWAP = "AXIS_SWAP"
